module.exports = __webpack_public_path__ + "img/shared.e1eb0b9f.svg";